import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { iconColors } from '@app/shared/constants';

@Component({
  selector: 'spinner',
  templateUrl: 'spinner.component.html',
  styleUrls: ['spinner.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SpinnerComponent implements OnChanges {
  @Input() public size = 'large';
  @Input() public colorName = 'black';

  @Input() public autId: string;

  public sizes = '50px';
  public color: string = iconColors.BLACK;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.size) {
      this.sizes = this.initSize();
    }

    if (changes.colorName) {
      this.color = this.setColors();
    }
  }

  initSize(): string {
    switch (this.size) {
      case 'small':
        return '26px';

      case 'xs':
        return '20px';

      case 'normal':
      default:
        return '50px';
    }
  }

  setColors() {
    switch (this.colorName) {
      case 'white':
        return iconColors.WHITE;

      case 'blue':
        return iconColors.BLUE;

      case 'orange':
        return iconColors.ORANGE;

      case 'red':
        return iconColors.BRIGHT_RED;

      case 'black':
      default:
        return iconColors.BLACK;
    }
  }
}
